export enum ServiceLevelAgreement {
  DEPARTMENT = 'SLA_PROFILE-DEPARTMENT',
  OFFICE = 'SLA_PROFILE-OFFICE',
  REC_STATUS = 'SLA_PROFILE-REC_STATUS',
  PROFILE_CHANGE_STATUS = 'SLA_PROFILE-PROFILE_CHANGE_STATUS',
  EFFECTIVE_DATE = 'EFFECTIVE_DATE',
  SLA_NAME = 'SLA_PROFILE-SLA_NAME',
  SLA_DESCRIPTION = 'SLA_PROFILE-SLA_DESCRIPTION',
  SLA_TYPE = 'SLA_PROFILE-SLA_TYPE',
  SLA_PRODUCT = 'SLA_PROFILE-SLA_PRODUCT',
  PRIORITY = 'SLA_PROFILE-PRIORITY',
  REGULATION = 'SLA_PROFILE-REGULATION',
  ADDED_DAYS_TO_STTLM_DATE = 'SLA_PROFILE-ADDED_DAYS_TO_STTLM_DATE',
  PROCESS_IMMEDIATLY = 'SLA_PROFILE-PROCESS_IMMEDIATLY',
  HOLD_MI_TO_MSG_PAY_TIME = 'SLA_PROFILE-HOLD_MI_TO_MSG_PAY_TIME',
  HOLD_MI_FROM_RECEIPT = 'SLA_PROFILE-HOLD_MI_FROM_RECEIPT',
  PROCESS_AFTER_TOD = 'SLA_PROFILE-PROCESS_AFTER_TOD',
  PROCESS_AFTER_TOD_TZ = 'SLA_PROFILE-PROCESS_AFTER_TOD_TZ',
  PROCESS_BEFORE_TOD = 'SLA_PROFILE-PROCESS_BEFORE_TOD',
  PROCESS_BEFORE_TOD_TZ = 'SLA_PROFILE-PROCESS_BEFORE_TOD_TZ',
  EARLIEST_PROC = 'SLA_PROFILE-EARLIEST_PROC',
  MIN_MINUTES_FROM_RECEIPT = 'SLA_PROFILE-MIN_MINUTES_FROM_RECEIPT',
  MINUTES_FROM_ACCEPTANCE = 'SLA_PROFILE-MINUTES_FROM_ACCEPTANCE',
  NOTIFY_MI_TO_PAY_TIME_CHK = 'SLA_PROFILE-NOTIFY_MI_TO_PAY_TIME_CHK',
  NOTIFY_MI_TO_PAY_TIME = 'SLA_PROFILE-NOTIFY_MI_TO_PAY_TIME',
  NOTIFY_MI_TO_CUTOFF_CHK = 'SLA_PROFILE-NOTIFY_MI_TO_CUTOFF_CHK',
  NOTIFY_MI_TO_CUTOFF = 'SLA_PROFILE-NOTIFY_MI_TO_CUTOFF',
	TIME_STAMP = 'TIME_STAMP',
  UID = 'VIRTUAL-UID',
  PROFILE_UPDATE_PK = 'PROFILE_UPDATE_PK',
  PU_TIME_STAMP = 'PU_TIME_STAMP',
  NOTE = 'NOTE'
}
